module.exports = __webpack_public_path__ + "img/panda5.331c6f46.png";